import JwtService from '@common/JwtService'
import { BASE_URL } from '@common/ApiService'

export const createConsumer = ({ channel, handler, params = {} }) => {
  const webSocketUrl = `${BASE_URL.replace('http', 'ws')}/cable`
  const socket = new WebSocket(webSocketUrl, [
    'pas',
    'actioncable-v1-json',
    'actioncable-unsupported',
    JwtService.getToken(),
  ])

  socket.onopen = (event) => {
    const msg = {
      command: 'subscribe',
      identifier: JSON.stringify({
        channel: channel,
        ...params,
      }),
    }
    socket.send(JSON.stringify(msg))
    if (handler.connected && typeof handler.connected === 'function') {
      handler.connected(event)
    }
  }

  socket.onclose = (event) => {
    if (event.reason === 'manual') return

    if (handler.disconnected && typeof handler.disconnected === 'function') {
      handler.disconnected(event)
    }
  }

  socket.onmessage = (event) => {
    const response = event.data
    const data = JSON.parse(response)

    if (data.type === 'ping') {
      return
    }

    if (data.message && handler.received && typeof handler.received === 'function') {
      handler.received(data.message)
    }
  }

  socket.onerror = () => {}

  socket.disconnect = socket.close

  return socket
}
